module.exports = [{'redirect': "/idx/404",
'path': "/idx/:pathMatch(.*)",
'name': "main"},
{'path': "/idx/404",
'component': () => import("@/views/error/404.vue"),
'title': "错误页面",
'meta': {"title":"错误页面","fullScreen":true},
'name': "e404"},
{'path': "/idx/login",
'component': () => import("@/views/login/login.vue"),
'title': "登录",
'meta': {"title":"登录","fullScreen":true},
'name': "login"},
{'path': "/idx/sjaiLogin",
'component': () => import("@/views/login/part/no-auth-sjai.vue"),
'title': "深教ai登录",
'meta': {"title":"深教ai登录","fullScreen":true},
'name': "sjaiLogin"},
{'path': "/idx/redirect",
'component': () => import("@/views/login/redirect.vue"),
'title': "登录",
'meta': {"title":"登录","fullScreen":true},
'name': "redirect"},
{'path': "/idx/findpass",
'component': () => import("@/views/find-pass"),
'title': "忘记密码",
'meta': {"title":"忘记密码","fullScreen":true},
'name': "findPass"},
{'path': "/idx/home",
'component': () => import("@/views/home/index.vue"),
'title': "首页",
'meta': {"title":"首页","fullScreen":true,"moduleKey":"home","configWhite":true},
'name': "home"},
{'path': "/idx/resource/square",
'component': () => import("@/views/resource/index-template.vue"),
'title': "资源共享",
'meta': {"title":"资源共享","moduleKey":"resourceApplication:square","checkPage":["resourceApplication:square"],"configWhite":true},
'name': "resource"},
{'path': "/idx/research/subject",
'component': () => import("@/views/research/subject/index.vue"),
'title': "活动专题",
'meta': {"title":"活动专题","configWhite":true,"checkPage":["research:square"]},
'name': "research"},
{'path': "/idx/research/activitySquare",
'component': () => import("@/views/research/activity-square/index.vue"),
'title': "联研活动广场",
'meta': {"title":"联研活动广场","configWhite":true,"checkPage":["activity:researchSquare"]},
'name': "researchActivitySquare"},
{'path': "/idx/research/subject/detail/:teachResearchId",
'component': () => import("@/views/research/subject-detail/index.vue"),
'title': "联合教研详情页",
'meta': {"title":"联合教研详情页","configWhite":true},
'name': "researchSubjectDetail"},
{'path': "/idx/research/subjectAnnouncement",
'component': () => import("@/views/research/announcement/index.vue"),
'title': "联合教研公告页",
'meta': {"title":"联合教研公告页","configWhite":true},
'name': "researchAnnouncement"},
{'path': "/idx/research/subjectNews",
'component': () => import("@/views/research/news/index.vue"),
'title': "联合教研新闻页",
'meta': {"title":"联合教研新闻页","configWhite":true},
'name': "researchSubjectNews"},
{'path': "/idx/research/subject/edit/:subjectId?",
'component': () => import("@/views/research/subject-edit/index.vue"),
'title': "联合教研专题编辑页",
'meta': {"title":"联合教研专题编辑页","configWhite":true},
'name': "researchSubjectEdit"},
{'path': "/idx/research/announcement/:announcementId",
'component': () => import("@/views/research/subject-announcement/index.vue"),
'title': "通知公告详情",
'meta': {"title":"通知公告详情","configWhite":true},
'name': "announcementDetail"},
{'path': "/idx/research/news/:newsId",
'component': () => import("@/views/research/subject-news/index.vue"),
'title': "新闻资讯详情",
'meta': {"title":"新闻资讯详情","configWhite":true},
'name': "newsDetail"},
{'path': "/idx/group/square",
'component': () => import("@/views/group/index/group.vue"),
'title': "协作组主页",
'meta': {"title":"协作组主页","moduleKey":"coopgroup:square","checkPage":["coopgroup:square"],"configWhite":true},
'name': "groupIndex"},
{'path': "/idx/group/square-lightblue",
'component': () => import("@/views/group-copy/index/group.vue"),
'title': "协作组主页复制",
'meta': {"title":"协作组主页复制","moduleKey":"coopgroup:square","checkPage":["coopgroup:square"],"configWhite":true},
'name': "groupIndexCopy"},
{'path': "/idx/group/search",
'component': () => import("@/views/group/search/search.vue"),
'title': "协作组搜索",
'meta': {"title":"协作组搜索","configWhite":true,"checkPage":["coopgroup:square"]},
'name': "groupSearch"},
{'path': "/idx/resource/publish",
'component': () => import("@/views/resource-issue"),
'title': "资源发布",
'meta': {"title":"资源发布"},
'name': "resourcePublish"},
{'path': "/idx/union/square",
'component': () => import("@/views/activity-square"),
'title': "联盟活动广场",
'meta': {"title":"联盟活动广场","moduleKey":"activity:unionSquare","checkPage":["activity:unionSquare"],"configWhite":true},
'name': "unionSquare"},
{'path': "/idx/activity/square/:type?",
'component': () => import("@/views/activity-square"),
'title': "活动广场",
'meta': {"title":"活动广场","moduleKey":"activity:square","checkPage":["activity:square"],"configWhite":true},
'name': "activitySquare"},
{'path': "/idx/activity/square/train",
'component': () => import("@/views/activity-square"),
'title': "活动广场",
'meta': {"title":"活动广场","moduleKey":"activity:square","checkPage":["activity:square"],"configWhite":true},
'name': "activitySquareTrain"},
{'path': "/idx/activity/search",
'component': () => import("@/views/activity-square/search.vue"),
'title': "活动搜索",
'meta': {"title":"活动搜索","checkPage":["activity:square"],"configWhite":true},
'name': "activitySearch"},
{'path': "/idx/element/ui/demo",
'component': () => import("@/views/element-ui-demo"),
'title': "element Demo",
'meta': {"fullScreen":true},
'name': "elementUiDemo"},
{'path': "/idx/training-star",
'component': () => import("@/views/training-star"),
'title': "研修之星",
'meta': {"title":"研修之星","moduleKey":"yanxiuStar:square","checkPage":["yanxiuStar:square"],"configWhite":true},
'name': "trainingStar"},
{'path': "/idx/information",
'component': () => import("@/views/news-notice"),
'title': "新闻资讯",
'meta': {"title":"新闻资讯","isShowBread":true},
'name': "information"},
{'path': "/idx/notice",
'component': () => import("@/views/news-notice"),
'title': "通知公告",
'meta': {"title":"通知公告","isShowBread":true},
'name': "notice"},
{'path': "/idx/information/detail",
'component': () => import("@/views/news-notice/detail.vue"),
'title': "新闻资讯详情",
'meta': {"title":"新闻资讯详情"},
'name': "informationDetail"},
{'path': "/idx/notice/detail",
'component': () => import("@/views/news-notice/detail.vue"),
'title': "通知公告详情",
'meta': {"title":"通知公告详情"},
'name': "noticeDetail"},
{'path': "/idx/banner/detail",
'component': () => import("@/views/news-notice/detail.vue"),
'title': "banner详情",
'meta': {"title":"banner详情"},
'name': "bannerDetail"},
{'path': "/idx/userCenter/userHomePage",
'component': () => import("@/views/user-home-page/index-new.vue"),
'title': "主页",
'meta': {"title":"主页","isUserCenter":true},
'name': "userHomePage"},
{'path': "/idx/userCenter/follow",
'component': () => import("@/views/personal-center/follow"),
'title': "关注",
'meta': {"title":"关注","isUserCenter":true},
'name': "followList"},
{'path': "/idx/userCenter/accountInfo",
'component': () => import("@/views/account-info"),
'title': "账号信息",
'meta': {"title":"账号信息","isUserCenter":true},
'name': "accountInfo"},
{'path': "/idx/userCenter/accountSecurity",
'component': () => import("@/views/account-security"),
'title': "账号安全",
'meta': {"title":"账号安全","isUserCenter":true},
'name': "accountSecurity"},
{'path': "/idx/userCenter/resource",
'component': () => import("@/views/my-resource"),
'title': "我的资源",
'meta': {"title":"我的资源","shortTitle":"资源","moduleKey":"resourceApplication:my","isUserCenter":true,"checkPage":["resourceApplication:my"]},
'name': "myResource"},
{'path': "/idx/userCenter/group",
'component': () => import("@/views/group/mygroup/index.vue"),
'title': "我的协作组",
'meta': {"title":"我的协作组","shortTitle":"协作组","moduleKey":"coopgroup:my","isUserCenter":true,"checkPage":["coopgroup:my"]},
'name': "myGroup"},
{'path': "/idx/userCenter/activity",
'component': () => import("@/views/activity-square/my-activity.vue"),
'title': "我的活动",
'meta': {"title":"我的活动","shortTitle":"活动","moduleKey":"activity:my","isUserCenter":true,"checkPage":["activity:my"]},
'name': "myActivity"},
{'path': "/idx/userCenter/train-course",
'component': () => import("@/views/strain/my-strain/train-course.vue"),
'title': "我的课程",
'meta': {"title":"我的课程","shortTitle":"课程","isUserCenter":true,"moduleKey":"train:my","checkPage":["train:my"]},
'name': "myTrainCourse"},
{'path': "/idx/userCenter/strain",
'component': () => import("@/views/strain/my-strain/strain-index.vue"),
'title': "我的学分",
'meta': {"title":"我的学分","shortTitle":"学分","moduleKey":"continuingEducation:my","isUserCenter":true,"checkPage":["continuingEducation:my"]},
'name': "myStrain"},
{'path': "/idx/userCenter/videocase",
'component': () => import("@/views/videocase-square/my-videocase.vue"),
'title': "我的案例",
'meta': {"title":"我的案例","shortTitle":"案例","moduleKey":"video:my","isUserCenter":true,"checkPage":["video:my"]},
'name': "myVideoCase"},
{'path': "/idx/userCenter/material",
'component': () => import("@/views/my-material/index.vue"),
'title': "我的素材库",
'meta': {"title":"我的素材库","shortTitle":"素材库","moduleKey":"material:my","isUserCenter":true,"checkPage":["material:my"]},
'name': "myMaterial"},
{'path': "/idx/userCenter/collect",
'component': () => import("@/views/my-collect/index.vue"),
'title': "我的收藏",
'meta': {"title":"我的收藏","isUserCenter":true,"checkPage":["collect:my"]},
'name': "myCollect"},
{'path': "/idx/userCenter/achievement",
'component': () => import("@/views/achievement/index.vue"),
'title': "我的成果",
'meta': {"title":"我的成果","isUserCenter":true,"checkPage":["growing:my"]},
'name': "achievement"},
{'path': "/idx/userCenter/achievement/add",
'component': () => import("@/views/achievement/add.vue"),
'title': "我的成果",
'meta': {"title":"我的成果","isUserCenter":true,"checkPage":["growing:my"]},
'name': "addAchievement"},
{'path': "/idx/userCenter/achievement/detail",
'component': () => import("@/views/achievement/detail.vue"),
'title': "我的成果",
'meta': {"title":"我的成果","isUserCenter":true,"checkPage":["growing:my"]},
'name': "detailAchievement"},
{'path': "/idx/videocase/square",
'component': () => import("@/views/videocase-square"),
'title': "优秀案例广场",
'meta': {"title":"优秀案例广场","moduleKey":"video:square","checkPage":["video:square"],"configWhite":true},
'name': "videoCaseSquare"},
{'path': "/idx/videocase/search",
'component': () => import("@/views/videocase-square/search.vue"),
'title': "案例搜索",
'meta': {"title":"案例搜索","checkPage":["video:square"],"configWhite":true},
'name': "videoCaseSearch"},
{'path': "/idx/course/square",
'component': () => import("@/views/strain/course/square/index.vue"),
'title': "课程广场",
'meta': {"title":"课程广场","moduleKey":"train:courseSquare","checkPage":["train:courseSquare"],"configWhite":true},
'name': "courseSquare"},
{'path': "/idx/schoolCourse/square",
'component': () => import("@/views/strain/course/square/school-index.vue"),
'title': "校本课程广场",
'meta': {"title":"校本课程广场","moduleKey":"train:schoolTrain:courseSquare","checkPage":["train:schoolTrain:courseSquare"],"configWhite":true},
'name': "schoolCourseSquare"},
{'path': "/idx/districtCourse/square",
'component': () => import("@/views/strain/course/square/district-index.vue"),
'title': "区级课程广场",
'meta': {"title":"区级课程广场","moduleKey":"train:districtTrain:courseSquare","checkPage":["train:districtTrain:courseSquare"],"configWhite":true},
'name': "districtCourseSquare"},
{'path': "/idx/course/details",
'component': () => import("@/views/strain/course/details/index.vue"),
'title': "课程详情",
'meta': {"title":"课程详情","isShowBread":true},
'name': "courseDetails"},
{'path': "/idx/brief-note/detail",
'component': () => import("@/views/news-notice/detail.vue"),
'title': "简报详情",
'meta': {"title":"简报详情","isShowBread":true},
'name': "briefNoteDetail"},
{'path': "/idx/brief/detail",
'component': () => import("@/views/news-notice/brief-note-detail.vue"),
'title': "简报详情",
'meta': {"title":"简报详情","isShowBread":true},
'name': "briefDetail"},
{'path': "/idx/mooc/square",
'component': () => import("@/views/mooc-square/index.vue"),
'title': "慕课广场",
'meta': {"title":"慕课广场","moduleKey":"moocApplication:square","checkPage":["moocApplication:square"],"configWhite":true},
'name': "moocSquare"},
{'path': "/idx/mooc/search",
'component': () => import("@/views/mooc-square/search.vue"),
'title': "慕课搜索",
'meta': {"title":"慕课搜索","checkPage":["moocApplication:square"],"configWhite":true},
'name': "moocSearch"},
{'path': "/idx/userCenter/mooc",
'component': () => import("@/views/mooc-square/my-mooc.vue"),
'title': "我的慕课",
'meta': {"title":"我的慕课","shortTitle":"慕课","moduleKey":"moocApplication:my","checkPage":["moocApplication:my"],"isUserCenter":true},
'name': "myMooc"},
{'path': "/idx/mooc/statistics",
'component': () => import("@/views/mooc-square/statistics.vue"),
'title': "数据统计",
'meta': {"title":"数据统计"},
'name': "moocStatistics"},
{'path': "/idx/userCenter/message",
'component': () => import("@/views/personal-center/message/index.vue"),
'title': "我的消息",
'meta': {"isUserCenter":true,"title":"我的消息"},
'name': "myMessage"},
{'path': "/idx/userCenter/dashboard",
'component': () => import("@/views/personal-center/dashboard/index.vue"),
'title': "我的数据看板",
'meta': {"isUserCenter":true,"title":"我的数据看板"},
'name': "dashboard"},
{'path': "/idx/userCenter/feedback",
'component': () => import("@/views/personal-center/feedback/index.vue"),
'title': "我的反馈",
'meta': {"isUserCenter":true,"title":"我的反馈"},
'name': "feedback"},
{'path': "/idx/login/wxCheck",
'component': () => import("@/views/login/wx-check.vue"),
'title': "微信绑定-校验",
'meta': {"fullScreen":true},
'name': "wxCheck"},
{'path': "/idx/login/wxBind",
'component': () => import("@/views/login/wx-bind.vue"),
'title': "微信绑定-绑定",
'meta': {"fullScreen":true},
'name': "wxBind"},
{'path': "/idx/new-teacher/square",
'component': () => import("@/views/new-teacher-course/index.vue"),
'title': "新教师项目课程",
'meta': {"title":"新教师项目课程","moduleKey":"train:projectCourses:square","checkPage":["train:projectCourses:square"],"configWhite":true},
'name': "newTeacherSquare"},
{'path': "/idx/new-teacher/details",
'component': () => import("@/views/new-teacher-course/detail.vue"),
'title': "新教师课程详情",
'meta': {"title":"新教师课程详情","isShowBread":true},
'name': "newTeacherDetail"},
{'path': "/idx/register",
'component': () => import("@/views/register/index.vue"),
'title': "注册",
'meta': {"fullScreen":true},
'name': "register"},
{'path': "/idx/double-new/home",
'component': () => import("@/views/home/double-new-index.vue"),
'title': "首页",
'meta': {"title":"首页","fullScreen":true,"moduleKey":"doubleNewHome","configWhite":true},
'name': "doubleNewHome"},
{'path': "/idx/resetPassword",
'component': () => import("@/views/resetPassword/index.vue"),
'title': "弱密码修改",
'meta': {"fullScreen":true},
'name': "resetPassword"},
{'path': "/idx/teachingStudio/square",
'component': () => import("@/views/teaching-studio/index.vue"),
'title': "工作室",
'meta': {"title":"工作室","moduleKey":"workshop:square","checkPage":["workshop:square"],"configWhite":true},
'name': "teachingStudio"},
{'path': "/idx/teachingStudio/square/dynamics",
'component': () => import("@/views/teaching-studio/square-dynamics/index.vue"),
'title': "工作室动态",
'meta': {"title":"工作室动态","configWhite":true},
'name': "teachingStudioDynamics"},
{'path': "/idx/teachingStudio/square/dynamics/result",
'component': () => import("@/views/teaching-studio/square-dynamics/index.vue"),
'title': "工作室动态",
'meta': {"title":"工作室动态","configWhite":true},
'name': "teachingStudioDynamicsResult"},
{'path': "/idx/userCenter/studio",
'component': () => import("@/views/teaching-studio/my-studio/index.vue"),
'title': "我的工作室",
'meta': {"title":"我的工作室","shortTitle":"工作室","moduleKey":"workshop:my","checkPage":["workshop:my"],"isUserCenter":true},
'name': "myStudio"},
{'path': "/idx/competition/fruit",
'component': () => import("@/views/competition/index.vue"),
'title': "赛事成果",
'meta': {"title":"赛事成果","fullScreen":true},
'name': "competitionFruit"},
{'path': "/idx/userCenter/competition",
'component': () => import("@/views/competition/my-fruit.vue"),
'title': "我的赛事",
'meta': {"title":"我的赛事","shortTitle":"赛事","moduleKey":"competition:my","isUserCenter":true,"checkPage":["competition:my"]},
'name': "myfruit"},
{'path': "/idx/competition/apply",
'component': () => import("@/views/competition/index.vue"),
'title': "赛事申请",
'meta': {"title":"赛事申请","fullScreen":true},
'name': "competitionApply"},
{'path': "/idx/competition/fruit/detail/:id",
'component': () => import("@/views/competition/index.vue"),
'title': "成果详情",
'meta': {"title":"成果详情","fullScreen":true},
'name': "fruitDetail"},
{'path': "/idx/userCenter/research",
'component': () => import("@/views/research/my-research.vue"),
'title': "我的专题",
'meta': {"title":"我的专题","shortTitle":"专题","moduleKey":"research:my","isUserCenter":true,"checkPage":["research:my"]},
'name': "myResearch"},
{'path': "/idx/userCenter/competition-new",
'component': () => import("@/views/competition-new/index.vue"),
'title': "我的赛事(新)",
'meta': {"title":"我的赛事（新）","shortTitle":"赛事（新）","moduleKey":"selection:my","isUserCenter":true,"checkPage":["selection:my"]},
'name': "myCompetitionNew"},
{'path': "/idx/20th-anniversary",
'component': () => import("@/views/20th-anniversary/index.vue"),
'title': "西城研修网20周年",
'meta': {"title":"西城研修网20周年","fullScreen":true},
'name': "anniversary"},
{'path': "/idx/project/home/:id",
'component': () => import("@/views/project/index.vue"),
'title': "课题门户",
'meta': {"title":"课题门户","moduleKey":"project:square","checkPage":["project:square"],"configWhite":true},
'name': "projectHome"},
{'path': "/idx/group/home",
'component': () => import("@/views/shenzhen/group/index.vue"),
'title': "协作组门户",
'meta': {"title":"协作组门户","fullMain":true},
'name': "groupHome"},
{'path': "/idx/userCenter/scientificResearch/:projectTypeId?",
'component': () => import("@/views/shenzhen/user-center/scientific-research.vue"),
'title': "教育科学规划课题",
'meta': {"title":"教育科学规划课题","shortTitle":"规划课题","moduleKey":"project:my","checkPage":["project:my"],"isUserCenter":true},
'name': "myScientificResearch"},
{'path': "/idx/result-selection/home/:id",
'component': () => import("@/views/shenzhen/result-selection/index.vue"),
'title': "成果奖评选广场",
'meta': {"title":"成果奖评选广场","moduleKey":"resultselection:square","checkPage":["resultselection:square"],"configWhite":true},
'name': "resultSelectionSquare"},
{'path': "/idx/result-cultivation/home/:id",
'component': () => import("@/views/shenzhen/result-cultivation/index.vue"),
'title': "成果培育广场",
'meta': {"title":"成果培育广场","moduleKey":"resultcultivation:square","checkPage":["resultcultivation:square"],"configWhite":true},
'name': "resultCultivationSquare"},
{'path': "/idx/userCenter/result-cultivation/:projectTypeId?",
'component': () => import("@/views/shenzhen/result-cultivation/my-result-cultivation.vue"),
'title': "教学成果奖",
'meta': {"title":"教学成果奖","shortTitle":"教学成果奖","moduleKey":"resultcultivation:my","checkPage":["resultcultivation:my"],"isUserCenter":true},
'name': "myResultCultivation"},
{'path': "/idx/userCenter/result-selection/:projectTypeId?",
'component': () => import("@/views/shenzhen/result-selection/my-result-selection.vue"),
'title': "优秀成果奖",
'meta': {"title":"优秀成果奖","shortTitle":"优秀成果奖","moduleKey":"resultselection:my","checkPage":["resultselection:my"],"isUserCenter":true},
'name': "myResultSelection"},
{'path': "/idx/expert-studio/home/:id",
'component': () => import("@/views/shenzhen/expert-studio/index.vue"),
'title': "科研工作室广场",
'meta': {"title":"科研工作室广场","moduleKey":"expertstudio:square","checkPage":["expertstudio:square"],"configWhite":true},
'name': "expertStudioSquare"},
{'path': "/idx/userCenter/expert-studio/:projectTypeId?",
'component': () => import("@/views/shenzhen/expert-studio/my-expert-studio.vue"),
'title': "课程体系改革项目",
'meta': {"title":"课程体系改革项目","shortTitle":"改革项目","moduleKey":"expertstudio:my","checkPage":["expertstudio:my"],"isUserCenter":true},
'name': "myExpertStudio"},
{'path': "/idx/basic-school/home/:id",
'component': () => import("@/views/shenzhen/basic-school/index.vue"),
'title': "科研基地校广场",
'meta': {"title":"科研基地校广场","moduleKey":"basicschool:square","checkPage":["basicschool:square"],"configWhite":true},
'name': "basicSchoolSquare"},
{'path': "/idx/userCenter/basic-school/:projectTypeId?",
'component': () => import("@/views/shenzhen/basic-school/my-basic-school.vue"),
'title': "创新计划项目",
'meta': {"title":"创新计划项目","shortTitle":"计划项目","moduleKey":"basicschool:my","checkPage":["basicschool:my"],"isUserCenter":true},
'name': "myBasicSchool"},
{'path': "/idx/scientific-research",
'component': () => import("@/views/scientific-research/index.vue"),
'title': "教育科研",
'meta': {"title":"教育科研","fullMain":true,"configWhite":true},
'name': "scientificResearch"},
{'path': "/idx/scientific-research/research-subject",
'component': () => import("@/views/project/index.vue"),
'title': "科研课题",
'meta': {"title":"科研课题","fullMain":true,"moduleKey":"project:square","checkPage":["project:square"],"configWhite":true},
'name': "scientificResearchSubject"},
{'path': "/idx/scientific-research/result-selection",
'component': () => import("@/views/shenzhen/result-selection/index.vue"),
'title': "成果奖评选",
'meta': {"title":"成果奖评选","fullMain":true,"moduleKey":"resultselection:square","checkPage":["resultselection:square"],"configWhite":true},
'name': "scientificResearchResultSelection"},
{'path': "/idx/scientific-research/result-cultivation",
'component': () => import("@/views/shenzhen/result-cultivation/index.vue"),
'title': "成果培育",
'meta': {"title":"成果培育","fullMain":true,"moduleKey":"resultcultivation:square","checkPage":["resultcultivation:square"],"configWhite":true},
'name': "scientificResearchResultCultivation"},
{'path': "/idx/scientific-research/basic-school",
'component': () => import("@/views/shenzhen/basic-school/index.vue"),
'title': "科研基地校",
'meta': {"title":"科研基地校","fullMain":true,"moduleKey":"basicschool:square","checkPage":["basicschool:square"],"configWhite":true},
'name': "scientificResearchBasicSchool"},
{'path': "/idx/scientific-research/expert-studio",
'component': () => import("@/views/shenzhen/expert-studio/index.vue"),
'title': "专家工作室",
'meta': {"title":"专家工作室","fullMain":true,"moduleKey":"expertstudio:square","checkPage":["expertstudio:square"],"configWhite":true},
'name': "scientificResearchExpertStudio"},
{'path': "/idx/scientific-research/project-center",
'component': () => import("@/views/project-center/index.vue"),
'title': "项目中心",
'meta': {"title":"项目中心","fullMain":true,"configWhite":true},
'name': "scientificResearchProjectCenter"},
{'path': "/idx/scientific-research/result-center",
'component': () => import("@/views/result-center/index.vue"),
'title': "成果中心",
'meta': {"title":"成果中心","fullMain":true,"configWhite":true},
'name': "scientificResearchResultCenter"},
{'path': "/idx/scientific-research/project-group",
'component': () => import("@/views/project-group/index.vue"),
'title': "科研课题组",
'meta': {"title":"科研课题组","fullMain":true,"configWhite":true},
'name': "scientificResearchProjectGroup"},
{'path': "/idx/teachingResearch/square",
'component': () => import("@/views/teaching-research/index.vue"),
'title': "教学研究",
'meta': {"title":"教学研究","fullMain":true,"configWhite":true},
'name': "teachingResearch"},
{'path': "/idx/matchCenter/square",
'component': () => import("@/views/match-center/index.vue"),
'title': "赛事中心",
'meta': {"title":"赛事中心","fullMain":true,"configWhite":true},
'name': "matchCenter"},
{'path': "/idx/userCenter/buddy/achievement",
'component': () => import("@/views/achievement/index.vue"),
'title': "我的成果",
'meta': {"title":"我的成果","isUserCenter":true,"checkPage":["aiBuddy:my:achivement"]},
'name': "myAchievement"},
{'path': "/idx/userCenter/advance",
'component': () => import("@/views/personal-center/advance/index.vue"),
'title': "我的进阶",
'meta': {"title":"我的进阶","isUserCenter":true,"checkPage":["aiBuddy:my:advance"]},
'name': "myAdvance"},
{'path': "/idx/userCenter/archives",
'component': () => import("@/views/personal-center/archives/index.vue"),
'title': "我的成长档案",
'meta': {"title":"我的成长档案","isUserCenter":true,"checkPage":["aiBuddy:my:profile"]},
'name': "myArchives"},
{'path': "/idx/userCenter/smart-push",
'component': () => import("@/views/personal-center/smart-push/index.vue"),
'title': "智能推送",
'meta': {"title":"智能推送","isUserCenter":true,"checkPage":["aiBuddy:my:push"]},
'name': "myPush"},
{'path': "/idx/hs-buddy-home",
'component': () => import("@/views/hs-buddy-home/index.vue"),
'title': "",
'meta': {"title":"","fullScreen":true},
'name': "hsBuddyHome"},
{'path': "/idx/userCenter/scientificResearchCenter/:projectType/:projectTypeId",
'component': () => import("@/views/shenzhen/user-center/scientific-research.vue"),
'title': "教育科学规划课题",
'meta': {"title":"教育科学规划课题","shortTitle":"规划课题","isUserCenter":true},
'name': "myScientificResearchCenter"}]